import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Box, IconButton, TextField } from "@material-ui/core";
import { Close as CloseIcon } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import songsAPI from "restApi/songsApi";

const useStyles = makeStyles((theme) => ({
  pickerRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 2),
  },
}));

// The song picker itself - always expanded, shown/hidden by the parent
// (which also coordinates it with AddNoteControl so only one "add"
// editor is open per section at a time, and the two collapsed triggers
// can sit on one compact row). Used per-section on the Event Detail
// page, so a leader can put a catalog song directly where it belongs
// instead of adding it Unsorted and dragging it over. Deliberately
// doesn't hide songs already on the event
// - picking one of those here just relocates it to this section (the
// backend treats it as a move, not an error), same end result as
// dragging it over would give.
export default ({ onAdd, onCancel }) => {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(true);
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    let cancelled = false;
    songsAPI.getSongs().then((res) => {
      if (cancelled) return;
      setOptions(res.data || []);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <Box className={classes.pickerRow}>
      <Autocomplete
        id="addSongToSection"
        style={{ flex: 1 }}
        options={options}
        getOptionLabel={(option) => `${option.title} - ${option.artist}`}
        loading={loading}
        openOnFocus
        onChange={(event, selected) => {
          if (selected) onAdd(selected);
        }}
        renderInput={(params) => (
          <TextField {...params} variant="standard" color="secondary" placeholder="Search songs" autoFocus />
        )}
      />
      <IconButton size="small" onClick={onCancel} title="Cancel">
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
  );
};
